import { Box, Grid, Typography } from "@material-ui/core";
import { MIcon, tokens } from "@cobee/cobee-ui";
import { translate } from "infrastructure/translate/localization";

export default function BenefitRequestCard({
  label,
  description,
  tag,
  onClick,
}: {
  label: string;
  description: string;
  onClick: () => void;
  tag?: string;
}) {
  return (
    <Grid key={label} className="benefit-request-container" onClick={onClick}>
      <Grid className="card">
        <Grid className="request-section">
          <Grid container alignItems="center">
            <Typography className="requestTitle">{translate(label)}</Typography>
            <Box
              sx={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
              }}
            >
              {tag ? (
                <Box className="new-message">{translate(tag)}</Box>
              ) : undefined}
              <MIcon.ChevronRight
                sx={{ color: tokens.palette.secondary.main }}
              />
            </Box>
          </Grid>
          <Typography variant="body2">{translate(description)}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
